import React, { useEffect } from 'react';
import { locales } from '../../../translations/locales';
import StatusSelection from './StatusSelection';
import translateEntries from '../../../controllers/translateEntries';

const Screen = (props) => {
    const { radio, locale } = props;

    useEffect(() => {

    }, [radio]);

    return (
        <div
            className={`row box_ecran_radio${radio.on ? '' : '_off'} text-truncate text-wrap`}
            id='ecran_radio'
        >
            {radio.on && (
                <div className='col'>
                    <div className='row'>
                        <div className='col text-center'>
                            {radio.vehicle.name}
                        </div>
                        <div className='col text-center'>
                            {radio.menuSelection && radio.n_selection}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col text-center'>
                            {
                                !radio.menuSelection ? translateEntries(radio.message, locale) : (
                                    <div className='row text-truncate'>
                                        <StatusSelection radio={radio} />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    {
                        radio.waitForAcknowledge ? (
                            <div className="position-absolute fixed-bottom btn btn-sm btn-success w-100 disabled">
                                {locales[radio.locale].sgo.acknowledge}
                            </div>
                        ) : (
                            <div className='position-absolute fixed-bottom btn btn-sm btn-light disabled'>
                                {locales[radio.locale].config.status}
                            </div>
                        )
                    }
                </div>
            )}
        </div>
    );
};

export default Screen;
